module.exports = __webpack_public_path__ + "img/q31-2.78ade4a2.jpg";